// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bs-tab-panel{padding:0 1em;position:relative}`, "",{"version":3,"sources":["webpack://./bs-ui/src/components/panel/BsTabPanel.scss"],"names":[],"mappings":"AAAA,cACE,aAAA,CACA,iBAAA","sourcesContent":[".bs-tab-panel {\n  padding: 0 1em;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
